import {
  rand,
  randBetweenDate,
  randCity,
  randEmail,
  randPhoneNumber,
  randStreetAddress,
} from '@ngneat/falso';
import {
  BillingEntityRegistrationNumberType,
  IPractice,
  IRoster,
  IScheduleRange,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  DayOfWeek,
  DAYS_OF_WEEK,
  MockGenerator,
  Properties,
  slugify,
  TIMEZONES,
  uid,
} from '@principle-theorem/shared';
import { AddressMock } from '../address/address.mock';

export class PracticeMock
  extends BaseFirestoreMock<Properties<IPractice>>
  implements Properties<IPractice>
{
  name = `${randCity()} Dental`;
  settings = {
    timezone: rand(TIMEZONES),
  };
  slug = slugify(this.name.toLowerCase());
  address = randStreetAddress();
  phone = randPhoneNumber();
  email = randEmail();
  websiteUrl = `https://www.${slugify(this.name.toLowerCase())}.com`;
  yearOpened = randBetweenDate({ from: '1980', to: new Date() }).getFullYear();
  schedule = MockPracticeSchedule();
  tyroSettings = {
    isEnabled: true,
    iClient: 'simulator',
    addCDBSAsPending: true,
  };
  smartpaySettings = {
    isEnabled: true,
  };
  verifoneSettings = {
    isEnabled: true,
  };
  hicapsConnectSettings = {};
  restrictions = {};
  enabledForSchedulingAggregateTrial = false;
  mohSettings = {
    claimFormEmail: 'claim@moh.com',
    preApprovalFormEmail: 'approval@moh.com',
  };
  accSettings = {
    enabled: true,
    testMode: true,
    vendorId: '123456789',
    providerId: '134444',
    facilityId: '987654321',
    pfxFilePath: '/path/to/file.pfx',
    pfxPassphrase: 'securepassphrase',
  };
  billingEntities = [
    {
      uid: uid(),
      isDefault: true,
      displayName: 'ABC Dental',
      entity: {
        registrationNumber: '1234',
        registrationNumberType: BillingEntityRegistrationNumberType.ABN,
        address: '123 Main St',
      },
      deleted: false,
    },
  ];
  metadata = { address: new AddressMock() };
  branding = {
    logoUrl: 'https://example.com/logo.png',
  };
  clickUpTaskId = '';
}

function MockPracticeSchedule(): IRoster {
  const operatingDays: DayOfWeek[] = DAYS_OF_WEEK;

  const shifts: IScheduleRange[] = [
    { from: '08:00', to: '18:00' },
    { from: '07:00', to: '17:00' },
  ];

  const schedule: IRoster = {
    days: [],
  };

  operatingDays.forEach((day: DayOfWeek) => {
    schedule.days.push({
      dayOfWeek: day,
      shift: rand(shifts),
    });
  });

  return schedule;
}

export const PRACTICE_NAMES: string[] = ['McMahons Point', 'North Sydney'];

// AI Suite Dashboard e2e (apps/principle-e2e) drives North Sydney and needs the
// analytics dashboard, which only renders when AI Receptionist is Enabled.
// testModeEnabled keeps the practice-write triggers (settings-sync/knowledge-base-sync)
// mocked, so seeding this fixture with functions running never fires live Ovie syncs.
const AI_RECEPTIONIST_ENABLED_PRACTICE = 'North Sydney';

export const PRACTICES: IPractice[] = PRACTICE_NAMES.map((name: string) => {
  const practice = MockGenerator.generate(PracticeMock, { name });
  if (name === AI_RECEPTIONIST_ENABLED_PRACTICE) {
    practice.settings = {
      ...practice.settings,
      aiReceptionist: { enabled: true, testModeEnabled: true },
    };
  }
  return practice;
});
